import React, { Component,useState } from 'react';
import RightSearchBar from '../components/RightSearchBar';
import MapCard from '../components/MapCard';
import Card from '../components/Card';
import SemanticTableHousing from '../components/SemanticTableHousing';
import Base from './Base';
import DateTimePicker from 'react-datetime-picker';
import UserStore from '../stores/UserStore';

require('dotenv').config()


class NewsAdminEdit extends Component {

  constructor() {

  super();
      this.state = {
          newsForm: {
              body: "",
              headline: "",
              id: null,
              publish: false,
              publish_date: "",
              staging: false,
              summary: "",
              type: "regular"
          }
      };

      this.updateNewsForm= this.updateNewsForm.bind(this);
      this.updateNews= this.updateNews.bind(this);
      this.createNews= this.createNews.bind(this);
      this.deleteNews= this.deleteNews.bind(this);
      this.setNewsForm= this.setNewsForm.bind(this);

  }

    setNewsForm(tmpNewsForm){
        tmpNewsForm['newsForm']['publish_date'] = tmpNewsForm['newsForm']['publish_date'].substring(0,19).replace(" ", "T")
        console.log(tmpNewsForm['newsForm']['publish_date'])
        this.setState({newsForm: tmpNewsForm['newsForm']});
    }


    updateNewsForm(event){
        let tmpNewsForm = this.state.newsForm;
        let fieldName = event.target.attributes.getNamedItem('name').value
        let fieldType = event.target.attributes.getNamedItem('type').value

        if(fieldType === "checkbox"){
            tmpNewsForm[fieldName] = event.target.checked;
        }else{
            tmpNewsForm[fieldName] = event.target.value;
        }
        this.setState({newsForm: tmpNewsForm});

    }


    updateNewsForm(event){
        let tmpNewsForm = this.state.newsForm;
        let fieldName = event.target.attributes.getNamedItem('name').value
        let fieldType = event.target.attributes.getNamedItem('type').value

        if(fieldType === "checkbox"){
            tmpNewsForm[fieldName] = event.target.checked;
        }else{
            tmpNewsForm[fieldName] = event.target.value;
        }
        this.setState({newsForm: tmpNewsForm});

    }

    /**
     * Delete news object
     */
    deleteNews(){
        if (window.confirm("Are you sure you want to delete \n [" + this.state.newsForm.headline + "]?")) {
            const requestOptions = {
                crossDomain:true,
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' }
            };
            fetch(global.apiUrl + '/v0/news/' + this.state.newsForm.id + '?access_token=' + UserStore.access_token, requestOptions)
                .then(response => {
                    if(response.status === 200){
                        this.props.history.push('/news/admin/list')
                        window.location.reload();
                    }else if(response.status === 408){
                        console.log("SOMETHING WENT WRONG")
                    }
                })
                .catch(console.log);
        }
    }
    
    /**
     * Update an existing news object
     */
    updateNews(){
        fetch(global.apiUrl + '/v0/news' + '?access_token=' + UserStore.access_token, {
            crossDomain:true,
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(this.state.newsForm)
        }).then((data) => {
           window.location.reload();
        }).catch(console.log);
    }

    /**
     * Create an news object
     */
    createNews(){
        fetch(global.apiUrl + '/v0/news' + '?access_token=' + UserStore.access_token, {
            crossDomain:true,
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.state.newsForm)
        }).then(response => {
            if(response.status === 200){
                this.props.history.push('/news/admin/list')
                window.location.reload();
            }else if(response.status === 408){
                console.log("SOMETHING WENT WRONG")
            }
        }).catch(console.log);
    }

  componentDidMount() {
      // Get news if we open edit with an id
      if(this.props.match.params.news_id){
          let newsId = this.props.match.params.news_id;

          const requestOptions = {
              crossDomain:true,
              method: 'GET',
              headers: { 'Content-Type': 'application/json' }
          };
          fetch(global.apiUrl + '/v0/news/' + newsId + '?access_token=' + UserStore.access_token, requestOptions)
              .then(res => res.json())
              .then((data) => {
                  this.setNewsForm({ newsForm: data});
              })
              .catch(console.log);
      }
      console.log(this.props.match.params);
     }

    render() {

        return (
        <Base pageTopic={"News"} mainContent={
            <>
                <Card title="News form" body={
                    <form>
                        <div className="form-group">
                            <label htmlFor="exampleInputEmail1">Headline</label>
                            <input name={"headline"} type="text"  onChange={this.updateNewsForm} className="form-control"
                                    placeholder="Headline"
                                   value={this.state['newsForm']['headline']} required />
                        </div>
                        <div className="form-group">
                            <label htmlFor="exampleInputPassword1">Type</label>
                            <select name={"type"} className="form-control" type="selector" onChange={this.updateNewsForm} value={this.state['newsForm']['type']}>
                                <option value="regular">Regular</option>
                                <option value="index">Index</option>
                                <option value="panel" hidden>Panel</option>
                                <option value="systeminfo" >systeminfo</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label className="form-check-label" htmlFor="exampleCheck1">Summary</label>
                            <textarea name={"summary"}  className="form-control" type="textarea" onChange={this.updateNewsForm} value={this.state['newsForm']['summary']} rows="10" required ></textarea>
                        </div>
                        <div className="form-group">
                            <label className="form-check-label" htmlFor="exampleCheck1">Body</label>
                            <textarea name={"body"} className="form-control" type="textarea" onChange={this.updateNewsForm} value={this.state['newsForm']['body']} rows="15" required ></textarea>
                        </div>
                        <div className="form-group">
                            <label className="form-check-label" htmlFor="exampleCheck1">Publish date</label>
                            <input name={"publish_date"}  className="form-control" onChange={this.updateNewsForm} type="datetime-local" value={this.state['newsForm']['publish_date']} required />
                        </div>
                        <div className="form-check">
                            <input name={"publish"}  className="form-check-input" onChange={this.updateNewsForm} type="checkbox" checked={this.state['newsForm']['publish']} required />
                                <label className="form-check-label" htmlFor="defaultCheck1">
                                    Publish
                                </label>
                        </div>
                        <div className="form-check">
                            <input name={"staging"} className="form-check-input" onChange={this.updateNewsForm} type="checkbox" checked={this.state['newsForm']['staging']}/>
                                <label className="form-check-label" htmlFor="defaultCheck1">
                                    Staging
                                </label>
                        </div>
                        {this.props.match.params.news_id && <button type="submit" onClick={this.updateNews} className="btn btn-primary">Update</button>}
                        {this.props.match.params.news_id && <button type="submit" onClick={this.deleteNews} className="btn btn-danger">Delete</button>}
                        {!this.props.match.params.news_id && <button type="submit" onClick={this.createNews} className="btn btn-primary">Create</button>}
                    </form>
                  }></Card>
          </>}
          ></Base>
	     )
  }
}

export default NewsAdminEdit;
